export default __webpack_public_path__ + "0f5e5a9a6f014dee972a7d7958959a50.svg";